<template>
  <v-dialog persistent width="480" v-model="active">
    <v-card>
      <v-card-title>Perfil de acceso</v-card-title>
      <v-card-text>
        <div class="text-body-2 mb-4">
          El usuario ingresado cuenta con varios perfiles en el sistema. ¿Con qué perfil desea entrar?
        </div>
        <v-list-item v-for="(perfil, index) in perfilesFiltrados" :key="index" link @click="enterApp(perfil)">
          <v-list-item-content>
            <v-list-item-title class="text-subtitle-1 font-weight-bold">{{ perfil }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <div v-if="perfilesFiltrados.length === 0" class="text-center text-body-2 grey--text">
          No se encontraron perfiles válidos para este usuario.
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import { PERFILES } from '@/perfiles.js'
import redirectToModuleByPerfil from '@/utils/redirectToModuleByPerfil'

export default {
  props: {
    active: {
      type: Boolean,
    },
  },
  data() {
    return {
      PERFILES,
    }
  },

  computed: {
    ...mapGetters({
      perfiles: 'getLoginPerfiles',
      idPersonal: 'getIdPersonal',
    }),

    perfilesFiltrados() {
      const perfilesValidos = Object.values(this.PERFILES)

      const perfilesFiltradosPorValidos = this.perfiles.filter((perfil) => perfilesValidos.includes(perfil))
      return [...new Set(perfilesFiltradosPorValidos)]
    },
  },

  methods: {
    ...mapMutations(['SET_PERFIL']),

    enterApp(perfil) {
      this.$emit('close')
      localStorage.setItem('perfil', perfil)
      this.SET_PERFIL(perfil)
      redirectToModuleByPerfil(perfil)
    },
  },
}
</script>
